import { render, staticRenderFns } from "./DeliveryDateBox.vue?vue&type=template&id=20f429bd&"
import script from "./DeliveryDateBox.vue?vue&type=script&lang=js&"
export * from "./DeliveryDateBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports